/**
 * Where Home's sidebar shows and what it selects. Beside Home's own pages it
 * also takes the Apps overview and Spaces; chats keep the Chat sidebar, and
 * an open app keeps its own.
 *
 * @module components/home/HomeSidebar.logic
 */
import { homePageOf } from "./homePaths";

const APPS_OVERVIEW = /^\/[^/]+\/apps\/?$/;

/** True where Home's sidebar shows in place of the section's own. */
export function foldsIntoHomeSidebar(pathname: string): boolean {
  const page = homePageOf(pathname);
  return APPS_OVERVIEW.test(pathname) || page === "spaces" || page === "space";
}

/** The rows of the nav block, top to bottom; all but Insights fold under More. */
export const HOME_NAV_ROWS = ["insights", "skills", "knowledge", "plugins", "automations"] as const;
export type HomeNavRow = (typeof HOME_NAV_ROWS)[number];

/** The nav row a pathname selects. Knowledge opens Governance, so it is never selected here. */
export function activeHomeNavRow(pathname: string): HomeNavRow | null {
  const page = homePageOf(pathname);
  if (page === "command-center") return "insights";
  if (page === "skills" || page === "skill") return "skills";
  const section = pathname.split("/")[2];
  if (section === "connections") return "plugins";
  if (section === "automations") return "automations";
  return null;
}

/** More stays open while one of its rows is selected, so the selection never folds away. */
export function moreHoldsOpen(pathname: string): boolean {
  const row = activeHomeNavRow(pathname);
  return row !== null && row !== "insights";
}
